export default __webpack_public_path__ + "assets/images/ad5b709cfc2770e24dcb23a832a5b8c5.svg";